import {
    FieldConfig,
    SmartMetadataCard,
} from '@common/components/MetadataCard';
import {
    useFormattedDate,
    useFormattedDuration,
} from '@common/hooks/formatters';
import { DeepPath } from '@common/types/deepPath';
import { useSelectedCollectionMetadata } from '@features/metadata/hooks';
import { CollectionMetadata } from '@features/metadata/types';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const GlobalInfoSection = () => {
    const { t } = useTranslation('collectionDetails');
    const { data: metadata, isLoading } = useSelectedCollectionMetadata();

    const { formatDate } = useFormattedDate({ year: 'numeric' });
    const { formatDuration } = useFormattedDuration();

    const config = useMemo(
        (): FieldConfig<CollectionMetadata>[] => [
            { key: 'title' },
            { key: 'proscopeId' },
            { key: 'productionYear', formatter: formatDate },
            { key: 'releaseYear', formatter: formatDate },
            { key: 'country' },
            { key: 'duration', formatter: formatDuration },

            { key: 'genres', formatter: (val) => val.join(', ') },
            { key: 'credits.music', formatter: (val) => val.join(', ') },
            { key: 'credits.writers', formatter: (val) => val.join(', ') },
        ],
        [formatDate, formatDuration],
    );

    const resolveLabel = useCallback(
        (key: DeepPath<CollectionMetadata>) => t(`metadata.${key}`),
        [t],
    );

    return (
        <SmartMetadataCard
            title={t('globalInformation')}
            resolveLabel={resolveLabel}
            isLoading={isLoading}
            source={metadata}
            config={config}
        />
    );
};
